import { Module } from 'vuex'
import { Wordpress } from '../types/Wordpress';
import { mutations } from './mutations'
import { getters } from './getters'
import { actions } from './actions'

export const module: Module<Wordpress, any> = {
  namespaced: true,
  state: {
    posts: [],
    press: [],
    allPages: null,
    currentPage: null,
    currentEdges: [],
    categories: [],
    currentPost: null,
    currentCategory: null,
    categoriesPreview: []
  },
  mutations,
  actions,
  getters
}
